import React,{useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Connection from '../../utils/Connection';
import Session from '../../utils/Session';

interface OtpVerificationProps {
    contactInfo: string;
    onLoginSuccess: (accessToken: string, refreshToken: string) => void;
}

const OTP: React.FC<OtpVerificationProps> = ({ contactInfo, onLoginSuccess }) => {
    const [otp, setOtp] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    const initializeSession = (accessToken: string, refreshToken: string) => {
        const ticket = { accessToken, refreshToken };
        const customer = { email: contactInfo };
        Session.set(ticket, customer);
    };

    const handleOtpVerification = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        const url = Connection.baseUrl('verify-login-code');
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Tenant-Code': 'lot',
                },
                body: JSON.stringify({ Email: contactInfo, Otp: otp }),
            });

            if (!response.ok) {
                throw new Error('Failed to verify OTP. Please try again.');
            }

            const data = await response.json();
            const { accessToken, refreshToken } = data.message;
            onLoginSuccess(accessToken, refreshToken);
            initializeSession(accessToken, refreshToken);

            if (Session.isAuthenticated()) {
               navigate('/patient');
            } else {
                setError('Failed to authenticate. Please try again.');
            }
        } catch (error: any) {
            setError(error.message || 'An unknown error occurred.');
        }
    };

    return (
        <div className="otp-container">
            <h2 className="otp-title">OTP Verification</h2>
            <form onSubmit={handleOtpVerification}>
                <div className="form-group">
                    <label>OTP:</label>
                    <input
                        type="text"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="submit-button">Verify OTP</button>
            </form>
            {error && <p className="error-message">{error}</p>}
        </div>
    );
};

export default OTP;

